import { useState } from 'react';

import { Dropdown } from '@gds/Dropdown/Dropdown';
import { useAtom } from 'jotai';

import { finCalcDataFieldValueAtom } from '../Atoms/FinCalcDataFieldValue.atom';
import { BaseField } from '../Entities/FinCalcFields.entity';

export const DropdownElement = ({
  id,
  dataTestId,
  label,
  options,
  isValid,
  errorMessage,
  isDisabled,
}: BaseField) => {
  const [value, setValue] = useAtom(finCalcDataFieldValueAtom(id));
  const [hasTouched, setHasTouched] = useState(false);

  const handleBlur = () => {
    setHasTouched(true);
  };

  return (
    <Dropdown
      label={label}
      dataTestId={dataTestId}
      options={options || []}
      onChange={e => setValue(e)}
      value={value || options![0].value}
      error={hasTouched && !isValid && errorMessage}
      onBlur={handleBlur}
      disabled={isDisabled}
    />
  );
};
